
namespace Gamification.Gamification {

    export interface RisorsePickerOptions {
        hideRisorse?: number[];
    }

    @Serenity.Decorators.registerClass()
    export class RisorseCheckGrid extends Serenity.EntityGrid<RisorseRow, RisorsePickerOptions> {
        protected getColumnsKey() { return RisorseCheckColumns.columnsKey; }
        protected getDialogType() { return RisorseDialog; }
        protected getIdProperty() { return RisorseRow.idProperty; }
        protected getLocalTextPrefix() { return RisorseRow.localTextPrefix; }
        protected getService() { return RisorseService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: RisorsePickerOptions) {
            super(container, options);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            return columns;
        }

        protected usePager() {
            return true;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            //
            var request = this.view.params as Serenity.ListRequest;
            //
            if (this.options.hideRisorse && this.options.hideRisorse.length) {
                /* */
                request.Criteria = Serenity.Criteria.and([[Gamification.RisorseRow.Fields.IdRisorsa], 'not in', [this.options.hideRisorse]], request.Criteria);
            }

            return true;
        }
    }
}